var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M18.54 7.12h-5.82l-1.8-5.54c-.29-.89-1.54-.89-1.83 0l-1.8 5.54H1.46C.53 7.12.14 8.31.9 8.86l4.71 3.42-1.8 5.54c-.29.89.73 1.62 1.48 1.07L10 15.47l4.71 3.42c.75.55 1.77-.19 1.48-1.07l-1.8-5.54 4.71-3.42c.76-.55.37-1.74-.56-1.74z"
  })));
}
export default __webpack_public_path__ + "d81852a003d1aba5d2dcd63df7f3c474.svg";
export { SvgStarFilled as ReactComponent };